import { isRejection, isTransientFailure } from "@/utils/network";
import {
  STALE_BUILD_FINGERPRINT,
  isDynamicImportError,
  staleBuildLevel,
} from "@/utils/staleBuild";

const isExpectedHttpFailure = (error) =>
  !!error?.response && (isRejection(error) || isTransientFailure(error));

const isStaleBuildFailure = (error) =>
  isDynamicImportError(error) && globalThis.navigator.onLine;

export const classifyExpectedFailure = (event, hint) => {
  if (event.tags?.pending_sync) return event;
  const error = hint?.originalException;
  if (isStaleBuildFailure(error)) {
    event.level = staleBuildLevel();
    event.fingerprint = STALE_BUILD_FINGERPRINT;
    return event;
  }
  if (isExpectedHttpFailure(error)) event.level = "warning";
  return event;
};
